// The static landing document (public/index.html) shows its own markup and
// skips mounting React for a logged-out visit to "/" (html:not(.app)). The
// app bundle (bootstrap.js) is dynamically imported ONLY when the shell's
// inline script has marked <html class="app"> -- i.e. every route other
// than the logged-out root. A static top-level `import "@/index.css"` would
// run (and inject Tailwind's global base/preflight CSS) regardless of this
// check, so the app entry point -- and its CSS -- must be code-split behind
// a dynamic import instead.
if (document.documentElement.classList.contains("app")) {
  import("./bootstrap").catch(() => {
    // Chunk failed to load (network blip or a deploy mid-flight) -- a blank
    // #root with no feedback is worse than one retry via a full reload.
    const key = "lp_bootstrap_reload";
    if (!sessionStorage.getItem(key)) {
      sessionStorage.setItem(key, "1");
      window.location.reload();
    }
  });
}

// Register Service Worker for PWA (only in production)
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    try {
      navigator.serviceWorker.register('/service-worker.js?v=8')
        .then((registration) => {
          registration.update();
        })
        .catch(() => {});
    } catch (e) {
      // Silent fail - SW not critical for app functionality
    }
  });
}
